export const chipDefault = ({ isLast }) => ({
    marginRight: isLast ? 0 : 4,
    marginBottom: 4,
});
